import React, { useEffect } from 'react';
import useWizardTree from '../../Hooks/useWizardTree';
import { WizardType } from '../../Enums/WizardType.enum';
import WizardItem from '../WizardItems/WizardItem';
import styles from './Wizard.module.scss';
import Loading from '../../../BaseModule/Components/Loading';
import { useWizardContext } from '../../Services/WizardContext';
import { useEffectAsync } from '../../../../helpers';

interface Props {
	wizardKey: string;
	type: WizardType;
	data: object;
}

const PostWizard: React.FC<Props> = ({ wizardKey, type, data }) => {
	const { activeScreen, setWizardScheme, wizardData, setWizardData } =
		useWizardContext();

	const { postWizard } = useWizardTree({
		wizardKey,
	});

	useEffect(() => {
		setWizardData(data);
	}, []);

	useEffectAsync(async () => {
		if (wizardData) {
			const wizard = await postWizard(wizardData);
			if (wizard) {
				setWizardScheme(wizard);
			}
		}
	}, [wizardKey, wizardData]);

	if (!activeScreen) {
		return (
			<div className={styles.loadingWrapper}>
				<Loading />
			</div>
		);
	}

	return (
		<div className={styles.wrapper} style={{ background: 'transparent' }}>
			<WizardItem item={activeScreen} type={type} />
		</div>
	);
};

export default PostWizard;
